export enum ModalTestEnum {
  TITLE = 'modal-title',
  BODY = 'modal-body',
  FOOTER = 'modal-footer',
  CLOSE_BTN = 'modal-close-btn',
}
